import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["containerType"];
import I18n from 'I18n';
import { createCrmObjectFetcher } from 'personalization-lib/api/clients/crmApiClient';
import { OBJECT_TYPE_IDS } from 'personalization-lib/constants/objectTypeIds';
import { WEB_INTERACTIVES_URL } from 'personalization-lib/constants/urls';
import { notHasProperty, propertyNotEquals } from 'personalization-lib/utils/assetData/crm';
import http from 'hub-http/clients/apiClient';
import { mapContentData } from 'personalization-lib/utils/assetData/content';
import { isValidWebInteractive } from 'personalization-lib/utils/assetData/webInteractives';
export const fetchWebInteractive = id => http.get(`${WEB_INTERACTIVES_URL}/${id}`).then(content => {
  return Object.assign({}, mapContentData(content), {
    isValidForPersonalization: isValidWebInteractive(content)
  });
});
const WEB_INTERACTIVE_CRM_PROPERTIES = {
  NAME: 'hs_name',
  UPDATED_AT: 'hs_updated_at',
  CONTENT_ID: 'hs_content_id',
  PERSONALIZATION_VARIANT_STATUS: 'hs_personalization_variant_status',
  PERSONALIZATION_STRATEGY_ID: 'hs_personalization_strategy_id',
  SCREENSHOT_URL: 'hs_screenshot_url',
  CONTAINER_TYPE: 'hs_container_type',
  IS_SMART: 'hs_is_smart_cta',
  IS_ACTIVE_AB_TEST: 'hs_is_active_ab_test',
  PARENT_SOURCE: 'hs_parent_source'
};
const WEB_INTERACTIVE_FILTERS = [propertyNotEquals(WEB_INTERACTIVE_CRM_PROPERTIES.IS_SMART, 'true'), propertyNotEquals(WEB_INTERACTIVE_CRM_PROPERTIES.IS_ACTIVE_AB_TEST, 'true'), notHasProperty(WEB_INTERACTIVE_CRM_PROPERTIES.PERSONALIZATION_STRATEGY_ID), propertyNotEquals(WEB_INTERACTIVE_CRM_PROPERTIES.CONTAINER_TYPE, 'EMBEDDED'), propertyNotEquals(WEB_INTERACTIVE_CRM_PROPERTIES.PARENT_SOURCE, 'FEEDBACK')];
export const fetchWebInteractivesOptions = createCrmObjectFetcher({
  objectTypeId: OBJECT_TYPE_IDS.WEB_INTERACTIVE,
  propertiesMap: {
    text: WEB_INTERACTIVE_CRM_PROPERTIES.NAME,
    value: WEB_INTERACTIVE_CRM_PROPERTIES.CONTENT_ID,
    screenshot: WEB_INTERACTIVE_CRM_PROPERTIES.SCREENSHOT_URL,
    containerType: WEB_INTERACTIVE_CRM_PROPERTIES.CONTAINER_TYPE
  },
  filters: WEB_INTERACTIVE_FILTERS
}, results => results.map(_ref => {
  let {
      containerType
    } = _ref,
    option = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, option, {
    help: containerType && I18n.text(`personalizationLib.variantForm.assetSelect.WEB_INTERACTIVE.help.${containerType}`)
  });
}));